import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IAcademicPositionsPayload, IInitialStateAcademicPositions} from "../types";
import {GetAcademicPositions, GetDeletePositions} from "./thunk";


const initialState: IInitialStateAcademicPositions = {
    academicPositions: [],
    academicPositionsRestore: [],
    isLoadingAcademicPositions: false,
    isViewAcademicPositions: false,
    selectedAcademicPositionsIDs: [],
    academicPositionsFiltered: []
}

const academicPositionsSlice = createSlice({
    name: "academicPositions",
    initialState,
    reducers: {
        setAcademicPositions: (state, action: PayloadAction<{
            data: IAcademicPositionsPayload[],
            defaultLanguage: string
        }>) => {

            const {data, defaultLanguage} = action.payload
            state.academicPositions = data.map((year) => ({
                id: year.id,
                status: year.status,
                translations: year.translations.map((translation) => ({
                    slug: translation.slug,
                    name: translation.name,
                    abbreviation:translation.abbreviation,
                })),
            }));

            state.academicPositionsFiltered = state.academicPositions.flatMap(
                (data) =>
                    data.translations
                        .filter((elem) => elem.slug === defaultLanguage && elem.name)
                        .map((elem) => ({
                            id: data.id,
                            name: elem.name as string,
                            abbreviation:elem.abbreviation,
                        }))
            );

        },
        deletedAcademicPositions: (state, action: PayloadAction<number>) => {
            const updateData = state.academicPositions.filter(
                (elem) => elem.id !== action.payload
            );
            state.academicPositions = updateData;
        },
        updateAcademicPositions: (state, action: PayloadAction<IAcademicPositionsPayload>) => {
            const updateData = action.payload;

            state.academicPositions = state.academicPositions.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setIsViewAcademicPositions:(state)=>{

            state.isViewAcademicPositions =!state.isViewAcademicPositions;
        },
        setAcademicPositionsRestore:(state, action) => {
            state.academicPositionsRestore = action.payload;
        },
        deletedRestoreAcademicPositions:(state,action)=>{
            const updateData = state.academicPositionsRestore.filter(
                (elem) => elem.id !== action.payload
            );
            state.academicPositionsRestore = updateData;
        },
        setSelectedAcademicPositionsIDs: (state, action) => {
            state.selectedAcademicPositionsIDs=action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAcademicPositions.pending, (state) => {
                state.isLoadingAcademicPositions = true;
            })
            .addCase(GetAcademicPositions.fulfilled, (state) => {
                state.isLoadingAcademicPositions = false;
            })
            .addCase(GetAcademicPositions.rejected, (state) => {
                state.isLoadingAcademicPositions = false;
            })
            .addCase(GetDeletePositions.pending, (state) => {
                state.isLoadingAcademicPositions = true;
            })
            .addCase(GetDeletePositions.fulfilled, (state) => {
                state.isLoadingAcademicPositions = false;
            })
            .addCase(GetDeletePositions.rejected, (state) => {
                state.isLoadingAcademicPositions = false;
            });
    },
})


export const{
    setAcademicPositions,
    deletedAcademicPositions,
    updateAcademicPositions,
    setAcademicPositionsRestore,
    deletedRestoreAcademicPositions,
    setSelectedAcademicPositionsIDs,
    setIsViewAcademicPositions
} =academicPositionsSlice.actions

export default academicPositionsSlice